<div class=" bg-gray-50 p-6">
  <div class="max-w-3xl mx-auto bg-white shadow-md rounded-2xl p-8">

    <h2 class="text-2xl font-semibold mb-6 text-gray-800">
      My Profile
    </h2>

    <div *ngIf="user() as userData" class="space-y-6">

      <!-- Name -->
      <div>
        <label class="text-sm text-gray-500">Full Name</label>
        <div class="mt-1 text-lg font-medium text-gray-800">
          {{ userData.name }}
        </div>
      </div>

      <!-- Email -->
      <div>
        <label class="text-sm text-gray-500">Email</label>
        <div class="mt-1 text-lg text-gray-800">
          {{ userData.email }}
        </div>
      </div>

      <!-- Phone -->
      <div>
        <label class="text-sm text-gray-500">Mobile</label>
        <div class="mt-1 text-lg text-gray-800">
          {{ userData.phone }}
        </div>
      </div>

      <!-- Role -->
      <div>
        <label class="text-sm text-gray-500">Role</label>
        <div class="mt-1 text-lg text-indigo-600 font-medium">
          {{ userData.role?.label }}
        </div>
      </div>

    </div>
  </div>
</div>